<app-header></app-header>

<div class="remove-data-page">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-lg-8">
        <div class="remove-data-card">
          <!-- Titre principal -->
          <h1 class="remove-data-title">Confirmation de Suppression de Données</h1>
          
          <!-- Sous-titre -->
          <h2 class="remove-data-subtitle">Confirmer la suppression définitive de vos données :</h2>
          
          <!-- Messages de succès et d'erreur -->
          <div *ngIf="showSuccess" class="alert alert-success alert-dismissible fade show" role="alert">
            <i class="bi bi-check-circle-fill me-2"></i>
            {{ successMessage }}
            <button type="button" class="btn-close" (click)="dismissSuccess()" aria-label="Close"></button>
          </div>
          
          <div *ngIf="showError" class="alert alert-danger alert-dismissible fade show" role="alert">
            <i class="bi bi-exclamation-triangle-fill me-2"></i>
            {{ errorMessage }}
            <button type="button" class="btn-close" (click)="dismissError()" aria-label="Close"></button>
          </div>

          <!-- Informations sur l'email -->
          <div *ngIf="email" class="email-info">
            <p class="email-text">
              <strong>Email concerné :</strong> {{ email }}
            </p>
          </div>
          
          <!-- Section Important -->
          <div class="important-section">
            <h3 class="important-title">⚠️ Attention - Action Irréversible :</h3>
            <ul class="important-list">
              <li>Cette action supprimera <strong>définitivement</strong> toutes vos données personnelles</li>
              <li>Vos fichiers convertis et l'historique de vos conversions seront supprimés</li>
              <li>Vos informations de compte et préférences seront effacées</li>
              <li>Cette action ne peut pas être annulée</li>
              <li>Vous ne pourrez plus accéder à vos données après confirmation</li>
            </ul>
          </div>
          
          
          <!-- Boutons d'action -->
          <div class="action-buttons">
            <button 
              type="button" 
              class="btn btn-danger confirm-btn"
              (click)="confirmDeletion()"
              [disabled]="isSubmitting || !email">
              <span *ngIf="!isSubmitting">
                <i class="bi bi-trash-fill me-2"></i>
                Confirmer la suppression de mes données personnelles
              </span>
              <span *ngIf="isSubmitting">
                <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Suppression en cours...
              </span>
            </button>
            
            <button 
              type="button" 
              class="btn btn-secondary home-btn"
              (click)="goToHome()">
              <i class="bi bi-house-fill me-2"></i>
              Retour à l'accueil
            </button>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>